import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(private readonly updates: SwUpdate) {
    if (!this.updates.isEnabled) {
      console.error('Service workers are disabled or not supported by this browser');
      return;
    }
    this.checkForUpdates();
    this.subscribeToUpdate();
  }

  checkForUpdates() {
    // Force a check for updates
    this.updates.checkForUpdate().then(() => {
      console.log('Initial update check completed');
    }).catch(err => {
      console.error('Error during initial update check:', err);
    });
  }

  subscribeToUpdate() {
    // Subscribe to version updates
    this.updates.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Downloading new app version: ${evt.version.hash}`);
          break;
        case 'VERSION_READY':
          console.log(`Current app version: ${evt.currentVersion.hash}`);
          console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
          this.showUpdateBanner();
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
          break;
      }
    });
  }

  showUpdateBanner() {
    const banner = document.getElementById('update-banner');
    if (banner) {
      banner.classList.add('show');
      const reloadLink = document.getElementById('reload-link');
      if (reloadLink) {
        reloadLink.addEventListener('click', () => {
          this.updates.activateUpdate().then(() => {
            document.location.reload();
            console.log("updated");
          });
        });
      }
    }
  }
}
